import { useEffect, useMemo } from 'react';

import { GridPaginationModel } from '@mui/x-data-grid';

import { useSearchLspBrandsQuery } from 'src/apps/brand-connect/api/generated/graphql';

import { transformBrandQueryDataToRowData } from '../transform-brand-query-data-to-row-data';
import { BrandRow } from '../types';

type ProcessedBrandsQueryProps = {
  onDataReceived?: (count: number) => void;
  paginationModel: GridPaginationModel;
  search?: string;
};

export const useProcessedBrandsQuery = ({
  search,
  paginationModel,
  onDataReceived,
}: ProcessedBrandsQueryProps) => {
  const { data, loading } = useSearchLspBrandsQuery({
    variables: {
      ...(search ? { search } : {}),
      pagination: {
        limit: paginationModel.pageSize,
        offset: paginationModel.page * paginationModel.pageSize,
      },
    },
  });

  const rows: BrandRow[] = useMemo(
    () => transformBrandQueryDataToRowData(data?.searchLspBrands.results),
    [data?.searchLspBrands.results],
  );

  const totalCount = data?.searchLspBrands.queryInfo.totalCount;

  // Call onDataReceived when we get new data
  useEffect(() => {
    if (totalCount !== undefined && totalCount !== null) {
      onDataReceived?.(totalCount);
    }
  }, [totalCount, onDataReceived]);

  return {
    rows,
    loading,
  };
};
